// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconMegaeth } from "../../../icons/full/build/icon-megaeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const MegaethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconMegaeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  MegaethIcon.displayName = 'MegaethIcon';
}

export default MegaethIcon;